document.addEventListener("DOMContentLoaded", function () {
  const content = document.querySelector(".za-para");
  const tocList = document.querySelector(".toc-list");

  if (!content || !tocList) return;

  const headings = content.querySelectorAll("h2, h3"); // You can add h4, etc. if needed
  let h2Counter = 0;
  let h3Counter = 0;

  headings.forEach((heading) => {
    // Clear any existing ID first
    heading.removeAttribute("id");

    const tag = heading.tagName.toLowerCase();

    if (tag === "h2") {
      h2Counter++;
      h3Counter = 0;
    } else if (tag === "h3") {
      h3Counter++;
    }

    const id = heading.textContent
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]/g, "");
    heading.setAttribute("id", id);

    const li = document.createElement("li");
    li.classList.add("toc-item");

    const a = document.createElement("a");
    a.href = `#${id}`;
    a.textContent = heading.textContent;

    li.appendChild(a);
    tocList.appendChild(li);
  });
});






// cost calculator 
function updateCalculator() {
  const cigsSlider = document.getElementById("cigsPerDay");
  if (!cigsSlider) return; // guard: element not present on this page
  const cigs = parseInt(cigsSlider.value);
  const percentage = ((cigs - cigsSlider.min) / (cigsSlider.max - cigsSlider.min)) * 100;
  cigsSlider.style.background = `linear-gradient(to right, #FEB301 0%, #FEB301 ${percentage}%, #D9D9D9 ${percentage}%, #D9D9D9 100%)`;
  const cigsPerDay = parseInt(cigsSlider.value);
  document.getElementById("cigsPerDayValue").textContent = cigsPerDay;
  const packPrice = parseFloat(document.getElementById("packPrice").value);
  const eliquidPrice = parseFloat(document.getElementById("eliquidPrice").value);
  const coilPrice = parseFloat(document.getElementById("coilPrice").value);

  const monthlySmokingCost = (cigsPerDay / 20) * packPrice * 30;
  const eliquidPerCig = 0.195;
  const coilPerCigs = 77;

  const eliquidRequired = Math.ceil(cigsPerDay * 30 * eliquidPerCig);
  const coilsRequired = (cigsPerDay * 30) / coilPerCigs;
  const monthlyVapingCost = ((eliquidRequired / 10) * eliquidPrice) + (coilsRequired * coilPrice);
  const monthlySavings = monthlySmokingCost - monthlyVapingCost;
  const annualSavings = monthlySavings * 12;

  document.querySelectorAll("#monthlySmokingCost").forEach(el => el.textContent = monthlySmokingCost.toFixed(2));
  document.getElementById("eliquidRequired").textContent = eliquidRequired;
  document.getElementById("coilsRequired").textContent = coilsRequired.toFixed(2);
  document.getElementById("monthlyVapingCost").textContent = monthlyVapingCost.toFixed(2);
  document.getElementById("monthlySavings").textContent = monthlySavings.toFixed(2);
  document.getElementById("annualSavings").textContent = annualSavings.toFixed(2);
}

document.addEventListener("DOMContentLoaded", updateCalculator);
// cost calculator End

// Eliquid Calculator
document.addEventListener("DOMContentLoaded", function () {
  const recipeNameEl = document.getElementById('recipeName');
  if (recipeNameEl) {
    recipeNameEl.addEventListener('input', function () {
      const name = this.value.trim();
      document.getElementById('flavour_name').textContent = name ? name : 'Your Recipe';
    });
  }
});

function changeValue(id, step) {
  const input = document.getElementById(id);
  let value = parseFloat(input.value) || 0;
  const min = parseFloat(input.min) || 0;
  value = Math.max(min, value + step);
  input.value = value;
}

function updateSliderBackground() {
  const pgSlider = document.getElementById("pgSlider");
  if (!pgSlider) return;
  const pg = parseInt(pgSlider.value);
  pgSlider.style.background = `linear-gradient(to right, #FEB301 0%, #FEB301 ${pg}%, #D9D9D9 ${pg}%, #D9D9D9 100%)`;
}

function updatePGVG() {
  const pgSlider = document.getElementById('pgSlider');
  if (!pgSlider) return;
  const pg = parseInt(pgSlider.value);
  document.getElementById('pgLabel').textContent = pg + '% PG';
  document.getElementById('vgLabel').textContent = (100 - pg) + '% VG';
}

function getNicotineBaseRatio() {
  const active = document.querySelectorAll('.za-main-strength')[0].querySelector('.za-pg-btn.active').textContent.trim();
  if (active === 'PG') return { pg: 100, vg: 0 };
  if (active === 'VG') return { pg: 0, vg: 100 };
  if (active === '30/70') return { pg: 30, vg: 70 };
  if (active === '50/50') return { pg: 50, vg: 50 };
  return { pg: 100, vg: 0 };
}

function getNicotineStrength() {
  const active = document.querySelectorAll('.za-main-strength')[1].querySelector('.za-pg-btn.active').textContent.trim();
  return parseFloat(active.replace('mg', '')) || 0;
}

function calculateEliquid() {
  const totalVolume = parseFloat(document.getElementById("totalVolume").value) || 0;
  const flavorPct = parseFloat(document.getElementById("baseNicStrength").value) || 0;
  const desiredStrength = parseFloat(document.getElementById("desiredStrength").value) || 0;

  const targetPg = parseFloat(document.getElementById("pgSlider").value) || 50;
  const targetVg = 100 - targetPg;

  const nicBaseRatio = getNicotineBaseRatio();
  const nicStrength = getNicotineStrength();

  const resultBody = document.getElementById("resultBody");
  resultBody.innerHTML = "";

  const rows = [];

  // Nicotine
  const nicAmount = (desiredStrength / nicStrength) * totalVolume;
  const nicPct = (nicAmount / totalVolume) * 100;

  // Flavour
  const flavorAmount = (flavorPct / 100) * totalVolume;

  if (flavorPct > 0) {
    rows.push({ name: "Flavour", amount: flavorAmount, pct: flavorPct });
  }

  rows.push({ name: "Nicotine Base", amount: nicAmount, pct: nicPct });

  // Remaining base volume
  const baseVolume = totalVolume - (nicAmount + flavorAmount);

  // Target PG/VG in ml
  const targetPgMl = (targetPg / 100) * totalVolume;
  const targetVgMl = (targetVg / 100) * totalVolume;

  // Contribution from nicotine base
  const nicPgMl = (nicBaseRatio.pg / 100) * nicAmount;
  const nicVgMl = (nicBaseRatio.vg / 100) * nicAmount;

  // Needed PG/VG from base
  let pgBaseAmount = Math.max(0, targetPgMl - nicPgMl);
  let vgBaseAmount = Math.max(0, targetVgMl - nicVgMl);

  // Total base needed
  const totalBaseRequired = pgBaseAmount + vgBaseAmount;

  // Scale if needed
  if (totalBaseRequired > baseVolume) {
    const scale = baseVolume / totalBaseRequired;
    pgBaseAmount *= scale;
    vgBaseAmount *= scale;
  }

  rows.push({
    name: "PG Base",
    amount: pgBaseAmount,
    pct: (pgBaseAmount / totalVolume) * 100,
  });

  rows.push({
    name: "VG Base",
    amount: vgBaseAmount,
    pct: (vgBaseAmount / totalVolume) * 100,
  });

  // Render result
  let totalAmount = 0;
  let totalGrams = 0;

  rows.forEach((row) => {
    const amt = parseFloat(row.amount.toFixed(2));
    totalAmount += amt;

    // Estimate density
    let density = 1.00;
    const name = row.name.toLowerCase();

    if (name.includes("nicotine base")) {
      const pgPart = nicBaseRatio.pg / 100;
      const vgPart = nicBaseRatio.vg / 100;
      density = (pgPart * 1.038) + (vgPart * 1.26);
    } else if (name.includes("pg")) {
      density = 1.038;
    } else if (name.includes("vg")) {
      density = 1.26;
    }

    const grams = parseFloat((amt * density).toFixed(2));
    totalGrams += grams;

    resultBody.innerHTML += `
      <tr>
        <td>${row.name}</td>
        <td>${amt}</td>
        <td>${grams.toFixed(2)}</td>
        <td>${row.pct.toFixed(2)}</td>
      </tr>`;
  });

  document.getElementById("totalMl").textContent = Math.ceil(totalAmount);

  document.getElementById("totalGrams").textContent = totalGrams.toFixed(2);
  document.getElementById("totalAmount").textContent = "100%";
  document.getElementById("resultTable").style.display = "table";
  document.getElementById("copyBtn").disabled = false;
}

function copyResult() {
  const table = document.getElementById('resultTable');
  const range = document.createRange();
  range.selectNode(table);
  const selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);
  document.execCommand('copy');
  selection.removeAllRanges();
  document.getElementById('copyMsg').textContent = 'Copied!';
}

// Activate pill-style buttons
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.za-main-strength').forEach(group => {
    group.addEventListener('click', function (e) {
      if (e.target.classList.contains('za-pg-btn')) {
        group.querySelectorAll('.za-pg-btn').forEach(btn => btn.classList.remove('active'));
        e.target.classList.add('active');
      }
    });
  });

  // Init visuals (only when elements exist on this page)
  updatePGVG();
  updateSliderBackground();
});
// Eliquid Calculator End